import { Controller } from "stimulus"
import * as toast from "../lib/toast.js";

import FormValidator from "../lib/form_validator.js"

export default class extends Controller {
  static targets = ['submitter'];

  connect() {
    this.validator = new FormValidator(this.element);
    this.element[this.identifier] = this;
  }

  fieldsetValid(fieldset) {
    return this.validator.fieldsetValid(fieldset);
  }

  pushToast(status, title, text, timeout=5000) {
    this.toast = toast.pushToast(status, title, text, timeout);
  }

  validate = (evt) => {
    evt.preventDefault()
    this.validator.formValid()
  }

  submit(event) {
    event.preventDefault();
    const results = this.validator.formValid();

    if (results.valid) {
      if (this.hasSubmitterTarget) {
        this.submitterTarget.setAttribute('disabled', 'disabled')
      }

      this.element.submit()
    }
  }

  submitClick(event) {
    this.submit(event);
  }
}